<template lang="html">
  <div>
    <toolbar v-if="!expandVersion" title="Personal Notification Settings">
  </toolbar>
    <v-layout column>
      <v-dialog v-model="showRegionsDialog"
                max-width="600">
        <v-card class="pa-4">
          <v-layout column>
            <span class="title">Select States/Provinces</span>
            <v-layout row wrap>
              <v-flex sm4 v-for="(region) in referencePoliticalRegions"
                      :key="region.postalCode">
                <v-checkbox :label="region.label"
                            v-model="politicalRegions"
                            :value="region.postalCode"/>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-spacer />
              <v-btn color="accent" @click="showRegionsDialog = false">OK</v-btn>
            </v-card-actions>
          </v-layout>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showPhoneDialog"
                max-width="400">
        <v-card class="pa-4">
          <v-layout column>
            <span class="title">Set up your contact phone</span>
            <v-layout row wrap>
              <v-text-field label="Contact Phone" v-model="contactPhone"/>
            </v-layout>
            <v-card-actions>
              <v-spacer />
              <v-btn color="accent"
                     :loading="loadingBtn"
                     :disabled="!contactPhone"
                     @click="saveContactPhone">Save</v-btn>
              <v-btn color="accent" flat @click="closePhoneDialog">Cancel</v-btn>
            </v-card-actions>
          </v-layout>
        </v-card>
      </v-dialog>

      <v-layout row v-if="hasSelectedSms && !userProfile.contactPhone && !expandVersion">
        <v-flex>
          <v-alert :value="true" color="accent" type="info">
            Set up a
            <a href="#"
               style="color: white;"
               @click.stop.prevent="showPhoneDialog = true">Phone Number</a>
            to receive text alerts
          </v-alert>
        </v-flex>
      </v-layout>
      <v-layout v-if="profileInfo && !expandVersion" class="my-2">
        <div class="headline ml-2">
          {{profileInfo.name}} - {{profileInfo.contactEmail}}
        </div>
        <v-spacer />
      </v-layout>

      <v-layout column v-if="loading && expandVersion">
        <v-flex class="text-md-center py-3">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-flex>
      </v-layout>

      <v-layout v-else-if="!expandVersion || (expandVersion && !loading)" column class="my-2">
        <v-card class="py-2 pl-4">
          <v-layout align-baseline>
            <div v-if="expandVersion" class="title mr-3 mt-2 mb-2">
              User notifications
            </div>
            <div v-else class="title mr-3 mt-4 mb-5">
              When and how to send notifications
            </div>
          </v-layout>
          <v-layout column v-if="isLoadboardEnabled">
            <v-flex>
              <span class="subheading">Loadboard Subscription</span>
              <ul class="ml-2">
                <li>When new loads are posted in the states you select</li>
                <li>Selected states:
                  <span class="font-italic"
                        v-if="!savedPoliticalRegions.length">No states selected.</span>
                  <template v-else>
                    <span :key="idx" v-for="(region, idx) in savedPoliticalRegions">
                      {{referencePoliticalRegionsMappedByPostalCode[region].label}}
                      <span v-if="(idx + 1) != savedPoliticalRegions.length">,</span>
                    </span>
                  </template>
                </li>
              </ul>
              <div class="justify-end">
                <v-btn class="primary ml-5" @click="showRegionsDialog = true">
                  Select States/Regions
                </v-btn>
              </div>
            </v-flex>
            <v-flex xs12 sm6 md3 class="pt-3">
              <v-layout row wrap>
                <v-flex class="md2 xs6">
                  <v-checkbox v-model="loadboard.sms" label="Text"/>
                </v-flex>
                <v-flex class="md2 xs6">
                  <v-checkbox v-model="loadboard.email" label="Email"/>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-divider v-if="isLoadboardEnabled"/>

          <v-layout :column="!expandVersion" :wrap="expandVersion">
            <v-layout class="mt-2" column sm12 v-if="isLoadboardEnabled">
              <v-flex>
                <span class="subheading">Listings Subscription</span>
                <ul class="ml-4">
                  <li v-if="isLoadboardBiddingEnabled">New and updated bids on your listings</li>
                  <li v-else>Activity on your listings</li>
                </ul>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pt-3">
                <v-layout row wrap>
                  <v-flex class="xs6" :class="{'md2': !expandVersion, 'md3': expandVersion}">
                    <v-checkbox v-model="listings.sms" label="Text"/>
                  </v-flex>
                  <v-flex class="xs6" :class="{'md2': !expandVersion, 'md3': expandVersion}">
                    <v-checkbox v-model="listings.email" label="Email"/>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-divider v-if="isLoadboardEnabled"/>

            <v-layout class="mt-2" column sm12>
              <v-flex>
                <span class="subheading">Load History Subscription</span>
                <ul class="ml-4">
                  <li>Pickup ETA Updates</li>
                  <li>Pickup</li>
                  <li>Delivery ETA Updates</li>
                  <li>Delivery</li>
                  <li>Chat Log Entries</li>
                </ul>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pt-3">
                <v-layout row wrap>
                  <v-flex class="xs6" :class="{'md2': !expandVersion, 'md3': expandVersion}">
                    <v-checkbox v-model="loadsInProgress.sms" label="Text"/>
                  </v-flex>
                  <v-flex class="xs6" :class="{'md2': !expandVersion, 'md3': expandVersion}">
                    <v-checkbox v-model="loadsInProgress.email" label="Email"/>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-divider/>

          </v-layout>

          <v-divider v-if="expandVersion"/>

          <v-layout :column="!expandVersion" :wrap="expandVersion">
            <v-layout class="mt-2" column sm12>
              <v-flex>
                <span class="subheading">Dispatching Subscription</span>
                <ul class="ml-4">
                  <li>Preferred Carrier Network (PCN) Invitations and Membership</li>
                  <li>Network Loads Available</li>
                  <li>Your Offered Loads Accepted</li>
                  <li>Activity on Network loads you follow</li>
                </ul>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pt-3">
                <v-layout row wrap>
                  <v-flex class="xs6" :class="{'md2': !expandVersion, 'md3': expandVersion}">
                    <v-checkbox v-model="dispatching.sms" label="Text"/>
                  </v-flex>
                  <v-flex class="xs6" :class="{'md2': !expandVersion, 'md3': expandVersion}">
                    <v-checkbox v-model="dispatching.email" label="Email"/>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-divider/>

            <v-layout class="mt-2" column sm12 v-if="isLoadboardBiddingEnabled">
              <v-flex>
                <span class="subheading">Bids Subscription</span>
                <ul>
                  <li>Outbid</li>
                  <li>Bid Accepted</li>
                  <li>Listing Closed</li>
                </ul>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pt-3">
                <v-layout row wrap>
                  <v-flex class="xs6" :class="{'md2': !expandVersion, 'md3': expandVersion}">
                    <v-checkbox v-model="bids.sms" label="Text"/>
                  </v-flex>
                  <v-flex class="xs6" :class="{'md2': !expandVersion, 'md3': expandVersion}">
                    <v-checkbox v-model="bids.email" label="Email"/>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-divider v-if="isLoadboardBiddingEnabled"/>
          </v-layout>

          <v-divider v-if="expandVersion"/>

          <v-layout pt-4>
            <v-flex sm3 class="mr-5">
              <sticky-footer>
              <v-btn class="accent" @click="updateSettings">
                Save Settings
              </v-btn>
              </sticky-footer>
            </v-flex>
          </v-layout>
        </v-card>
      </v-layout>

    </v-layout>
  </div>
</template>

<script>
import _ from 'lodash';
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import * as types from '@/store/mutationTypes';
import Toolbar from '@/components/Toolbar';
import StickyFooter from '@/components/StickyFooter';
import pluginMixin from '@/mixins/pluginMixin';

export default {
  name: 'NotificationSettings',
  components: {
    Toolbar,
    StickyFooter,
  },
  mixins: [
    pluginMixin
  ],
  props: {
    userId: {
      type: String,
      default() {
        return null;
      },
    },
    expandVersion: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data: () => ({
    politicalRegions: [],
    savedPoliticalRegions: [],
    showPhoneDialog: false,
    contactPhone: null,
    showRegionsDialog: false,
    loadingBtn: false,
    callUpdateSettings: false,
    profileInfo: null,
    loading: false,
    loadboard: {
      sms: false,
      email: false,
      app: false,
    },
    loadsInProgress: {
      sms: false,
      email: false,
      app: false,
    },
    dispatching: {
      sms: false,
      email: false,
      app: false,
    },
    loadsInSettlement: {
      sms: false,
      email: false,
      app: false,
    },
    bids: {
      sms: false,
      email: false,
      app: false,
    },
    listings: {
      sms: false,
      email: false,
      app: false,
    },
  }),
  computed: {
    ...mapState('profiles', {
      userProfile: 'userProfile',
    }),
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    authProviderId() {
      return this.$route.params.authProviderId;
    },
    referencePoliticalRegions() {
      return this.currentActivePlugins.loadboard.states;
    },
    referencePoliticalRegionsMappedByPostalCode() {
      return _.keyBy(this.referencePoliticalRegions, region => region.postalCode);
    },
    hasSelectedSms() {
      return this.loadboard.sms || this.loadsInProgress.sms || this.dispatching.sms ||
        this.loadsInSettlement.sms || this.bids.sms || this.listings.sms;
    },
  },
  methods: {
    closePhoneDialog() {
      this.showPhoneDialog = false;
      this.callUpdateSettings = false;
    },
    async saveContactPhone() {
      this.loadingBtn = true;
      const user = {
        briefBio: this.userProfile.briefBio || '',
        contactEmail: this.userProfile.contactEmail || '',
        contactPhone: this.contactPhone || '',
        displayName: this.userProfile.name,
        profileImageUrl: this.userProfile.profileImageUrl,
        userAuthId: this.userProfile.authProviderId,
      };

      await API.user.updateContactInfo({ user });
      this.$store.dispatch('profiles/getUser');
      this.$store.dispatch('profiles/getUserProfile');

      this.loadingBtn = false;
      this.showPhoneDialog = false;

      if (this.callUpdateSettings) {
        this.updateSettings();
      }
    },
    async updateSettings() {
      if (!this.userProfile.contactPhone && this.hasSelectedSms && !this.authProviderId) {
        this.showPhoneDialog = true;
        this.callUpdateSettings = true;
      } else {
        this.$store.commit(`applications/${types.START_LOADING}`);
        this.callUpdateSettings = false;
        try {
          const settings = {
            bids: this.bids,
            listings: this.listings,
            loadboard: this.loadboard,
            dispatching: this.dispatching,
            loadsInProgress: this.loadsInProgress,
            loadsInSettlement: this.loadsInSettlement,

            politicalRegions: this.politicalRegions,
          };

          if (this.authProviderId) {
            await API.user.updateUserNotificationSettings({
              userAuthId: this.authProviderId, settings,
            });
          } else {
            await API.user.updateMyNotificationSettings({ settings });
          }

          this.initialize(settings);

          this.$store.dispatch('applications/setSuccessNotification', {
            message: 'Settings updated',
            timeout: 7000,
          });
        } catch (error) {
          this.$store.dispatch('applications/setErrorNotification', {
            message: error.message,
          });
        } finally {
          this.$store.commit(`applications/${types.END_LOADING}`);
        }
      }
    },
    initialize(settings) {
      this.bids = settings.bids;
      this.listings = settings.listings;
      this.loadboard = settings.loadboard;
      this.dispatching = settings.dispatching;
      this.loadsInProgress = settings.loadsInProgress;
      this.loadsInSettlement = settings.loadsInSettlement;

      this.politicalRegions = settings.politicalRegions;
      this.savedPoliticalRegions = _.clone(settings.politicalRegions);
    },
  },
  async created() {
    try {
      if (!this.expandVersion) {
        this.$store.commit(`applications/${types.START_LOADING}`);
      } else {
        this.loading = true;
      }

      let response;
      if (this.authProviderId) {
        response = await API.user.getUserNotificationSettings({ userAuthId: this.authProviderId });
        API.user.getUserProfile({ userId: this.authProviderId }).then((apiResponse) => {
          this.profileInfo = apiResponse.data;
        });
      } else if (this.userId) {
        const apiResponse = await API.user.getUserProfile({ userId: this.userId });
        this.profileInfo = apiResponse.data;
        response = await API.user.getUserNotificationSettings({
          userAuthId: this.profileInfo.authProviderId,
        });
      } else {
        response = await API.user.getMyNotificationSettings();
      }

      this.initialize(response.data);
    } catch (error) {
      this.$store.dispatch('applications/setErrorNotification', { message: error.message });
    } finally {
      if (!this.expandVersion) {
        this.$store.commit(`applications/${types.END_LOADING}`);
      } else {
        this.loading = false;
      }
    }
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/User/NotificationSettings.vue